export default __webpack_public_path__ + "static/11-evolved-23f209bd483dec35f0cf77f7ce6eaae0.jpg";